import React from 'react';
import Footer from '../Layout/Footer';
import LeftNav from '../Layout/LeftNav';

const Hoc = (BaseComponent) => {
  return function EnhancedComponent(props) {
    return (
      <div className="flex h-screen bg-gray-50 overflow-hidden">
        {/* Left Sidebar Navigation */}
        <LeftNav />
        <Footer />
        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <main className="flex-1 overflow-y-auto pb-6">
            <BaseComponent {...props} />
          </main>
          
        </div>
      </div>
    );
  };
};

export default Hoc;